module.exports = __webpack_public_path__ + "img/247_support.bd2cd4b7.png";